export const QUOTES_V2_BLOTTER_PREFIX = 'principal/quotesv2';
